import React from "react";
import { useForm } from "react-hook-form";

export function Step00({ onSubmit, store }) {
  const { handleSubmit } = useForm({
    defaultValues: store,
  });

  return (
    <form id="divorce-form" onSubmit={handleSubmit(onSubmit)}>
      <p className="font-bold text-xl text-center mt-4">
        Free Separation Easy Plan
      </p>
      <p className="font-medium text-lg text-left mt-4">
        If you have separated and you need help understanding what steps you
        need to take to legally divide your assets, you’re at the right place.{" "}
      </p>
      <p className="font-medium text-lg text-left mt-4">
        We will provide you with a free personalised strategy plan so you know
        exactly what you need to do.
      </p>
      <p className="font-medium text-lg text-left mt-4">
        Answer a few questions online. Takes 5 to 10 minutes.
      </p>
      <p className="font-medium text-lg text-left mt-4">
        We will then organise a free call with a lawyer to discuss your
        circumstances
      </p>

      <p className="font-medium text-lg text-left mt-4">
        Free. Confidential. No obligation.
      </p>
    </form>
  );
}
